import { InjectionToken } from '@angular/core';
export var DESIGNER_SETTINGS = new InjectionToken('DESIGNER_SETTINGS');
